import Vue from "vue";
import Vuex from "vuex";
import { getFolderDetails } from "../../utils/apiFunctions";

Vue.use(Vuex);

// State
const state = () => ({
  active: "",
  LoaderStatus: false,
  userAdded: 0,
  fetch: false,
  folderContent: {},
  folders: [],
});

// getters
const getters = {
  getActive: (state) => state.active,
  getLoaderStatus: (state) => state.LoaderStatus,
  getFetch: (state) => state.fetch,
  getFolderContent: (state) => state.folderContent,
  getFolders: (state) => state.folders,
  getExpand: (state) => state.folderExpand,
  getUserAdded: (state) => state.userAdded,
};

// actions
const actions = {
  async getContent(state, payload) {
    const response = await getFolderDetails(payload);
    if (response.status == 200) {
      state.commit("addFolderContent", response.data.data.content);
      return response.data.data.breadCrums;
    }
    return {};
  },
};

// mutations
const mutations = {
  setUserAdded(state) {
    let users = state.userAdded;
    state.userAdded = users + 1;
  },
  addFolderContent(state, payload) {
    state.folderContent = payload;
  },
  setActive(state, payload) {
    state.active = payload;
  },
  saveFolders(state, payload) {
    state.folders = payload;
  },
  addFolder(state, payload) {
    state.folders.unshift(payload);
  },
  setFetch(state, payload) {
    state.fetch = payload;
  },
  setLoader(state, payload) {
    state.LoaderStatus = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
